/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to generate content specs and create them
 */
define([], () => {
	class ContentProviderAPI {
		/**
		 * @public
		 * @function ContentProviderAPI#addModel
		 * @description Adds a new model to the boardModel
		 * @param {Object} content
		 * @param {String} content.type Content provider type to use.
		 * @param {Object} content.properties An object of property names & values to apply to the content.
		 * @param {TransactionToken} transactionToken
		 * @returns {Promise} Promise resolved with the added model id
		 */
		addModel() {}

		/**
		 * @public
		 * @function ContentProviderAPI#createContent
		 * @description Creates a content object
		 * @param {Object} options Parameters to pass to the content class for instantiation
		 * @returns {Content} The content object
		 */
		createContent() {}

		/**
		 * @public
		 * @function ContentProviderAPI#getTypeList
		 * @description Get the list of supported content types
		 * @returns {Array} A list of the supported content types
		 */
		getTypeList() {}

	}

	return ContentProviderAPI;
});
